var map = {
	"./1_Sanvo.png": 3108,
	"./2_CadelPoggio.png": 3771,
	"./3_Lazzarin.png": 7154,
	"./4_Bibanesi.png": 5272,
	"./CanonDoro.png": 4609,
	"./CentroMedicina.png": 4191,
	"./DlTech.png": 2982,
	"./Ferrarelle.png": 1535,
	"./GruppoYec.png": 3169,
	"./Meitei.png": 5942,
	"./Otherwise.png": 938,
	"./RossoBasilico.png": 9791,
	"./Saccol.png": 6359,
	"./Stella.png": 3089
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7127;